import { render } from "./PasswordListView.vue?vue&type=template&id=496acdf6&scoped=true&ts=true"
import script from "./PasswordListView.vue?vue&type=script&lang=ts"
export * from "./PasswordListView.vue?vue&type=script&lang=ts"

import "./PasswordListView.vue?vue&type=style&index=0&id=496acdf6&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496acdf6"]])

export default __exports__